<template>
    <b-modal id="modal_form"
     ref="modal_form"
     :title="modal_titulo"
     :ok-title="modal_botao"
     close-title="Fechar"
     cancel-title="Cancelar"
     no-close-on-backdrop
     :ok-disabled=form.errors.any()
     v-model="showModal"
     @ok="handleOk">
         <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
           <label>Nome *</label>
           <b-form-input type="text"
                         placeholder="Nome"
                         v-model="form.nome"
                         name="nome"
                         >
           </b-form-input>
           <b-form-feedback class="text-danger" v-text="form.errors.get('nome')" v-if="form.errors.has('nome')"></b-form-feedback>

             <label>Email *</label>
             <b-form-input type="text"
                           placeholder="Email"
                           v-model="form.email"
                           name="email"
                           >
             </b-form-input>
             <b-form-feedback class="text-danger" v-text="form.errors.get('email')" v-if="form.errors.has('email')"></b-form-feedback>

             <div v-if="this.modal_acao=='i'">
             <label>Empresa</label>
             <multiselect v-model="form.empresa"
             :options="optionsListItemBclienteUsuario"
             track-by="bcliente_id"
             label="label"
             :limit="10"
             :multiple="false"
             :clear-on-select="false"
             :hide-selected="true"
             placeholder="Selecione"
             tag-placeholder="Selecionar"
             select-label="Selecionar"
             selected-label="Selecionado"
             deselect-label="Remover"
             ></multiselect>
             <b-form-feedback class="text-danger" v-text="form.errors.get('empresa')" v-if="form.errors.has('empresa')"></b-form-feedback>
            </div>

            <div v-if="this.modal_acao=='i'">
              <label>Unidade ( Só serão listadas as unidades da empresa conectada )</label>
              <multiselect v-model="form.unidade"
              :options="optionsListItemUnidadeUsuario"
              track-by="unidade_id"
              label="label"
              :limit="10"
              :multiple="true"
              :clear-on-select="false"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              ></multiselect>
              <b-form-feedback class="text-danger" v-text="form.errors.get('unidade')" v-if="form.errors.has('unidade')"></b-form-feedback>
             </div>

              <div v-if="this.modal_acao=='i'">
                  <label>Role ( Só serão listadas as roles da empresa conectada )</label>
                  <multiselect v-model="form.role"
                  :options="optionsListItemRoleUsuario"
                  track-by="role_id"
                  label="label"
                  :limit="10"
                  :multiple="true"
                  :clear-on-select="false"
                  :hide-selected="true"
                  placeholder="Selecione"
                  tag-placeholder="Selecionar"
                  select-label="Selecionar"
                  selected-label="Selecionado"
                  deselect-label="Remover"
                  ></multiselect>
                  <b-form-feedback class="text-danger" v-text="form.errors.get('role')" v-if="form.errors.has('role')"></b-form-feedback>
              </div>

              <label>Status</label>
              <b-form-group>
                <b-form-radio-group
                  v-model="form.status"
                  :options="optionsLivStatus"
                  name="status"
                  stacked
                  plain
                ></b-form-radio-group>
              </b-form-group>
              <b-form-feedback v-text="form.errors.get('status')"  v-if="form.errors.has('status')"></b-form-feedback>
              <label>Acesso</label>
              <b-form-group>
                <b-form-radio-group
                  v-model="form.tp_acesso"
                  :options="this.$parent.optionsTpAcesso"
                  name="tp_acesso"
                  stacked
                  plain
                ></b-form-radio-group>
              </b-form-group>
              <b-form-feedback v-text="form.errors.get('tp_acesso')"  v-if="form.errors.has('tp_acesso')"></b-form-feedback>

            <label>Transportadora</label>
            <multiselect
              v-model="transportadoraSelected"
              :options-limit="300"
              :limit="2"
              :limit-text="limitText"
              :options="optionsTransportadora"
              track-by="value"
              label="label"
              id="transportadora"
              :hide-selected="true"
              placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              :searchable="true"
              :loading="isLoadingTransportadora"
              @search-change="listaTransportadora"
            ></multiselect>
            <b-form-feedback v-text="form.errors.get('pessoa_id_trn')"  v-if="form.errors.has('pessoa_id_trn')"></b-form-feedback>
         </form>
     <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
              <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
              <b-btn @click="showModal=false" variant="secondary">
                Fechar
              </b-btn>
              <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                Enviar
              </b-btn>
            </div>
     </div>
    </b-modal>
</template>
<script>
import AvisoErros from '../components/AvisoErros'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      showPopover: false,
      isLoadingTransportadora: false,
      transportadoraSelected: [],
      optionsTransportadora: [],
      statusSelected: [],
      optionsLivStatus: [],
      optionsListItemUnidade: [],
      optionsListItemUnidadeUsuario: [],
      optionsListItemBcliente: [],
      optionsListItemBclienteUsuario: [],
      optionsListItemRole: [],
      optionsListItemRoleUsuario: [],
      errors_array: [],
      form: new Form({
                nome: '',
                email: '',
                status: '',
                dt_ult_ace:'',
                usuario_id: '',
                pessoa_id_trn: '',
                tp_acesso: '',
                empresa: [],
                unidade: [],
                role: []
            }),
     helpForm: new Form({statusRecord: [], params: [], search: ''}),
    fields: [
      {
          name: '__checkbox',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      },
      {
        name: 'cd',
        title: 'Código',
        sortField: 'cd'
      },
      {
        name: 'descr',
        title: 'Descrição',
        sortField: 'descr'
      },
      {
        name: '__slot:status',
        title: 'Status',
        sortField: 'status'
      },
      {
          name: '__slot:actions',   // <----
          title: 'Ações',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      }
  ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
mounted() {
    this.getLivStatus();
  },
  watch: {
  transportadoraSelected(obj){
    this.form.pessoa_id_trn = obj.value;
  },
},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.usuario_id);
        }
    },
    onCreate ()
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.errors_array = '';
      this.errors_array = [];
      this.optionsListItemBclienteUsuario = [];
      this.optionsListItemBcliente = [];
      this.optionsListItemRole = [];
      this.optionsListItemRoleUsuario = [];
      this.optionsListItemUnidade = [];
      this.optionsListItemUnidadeUsuario = [];
      this.transportadoraSelected = [];
      this.optionsLivStatus = [];
      this.form.reset();
      this.form.tp_acesso = 1;
      this.$parent.optionsListItemBclienteUsuario.forEach((obj)=>
      {
        const item = { label: obj.label, bcliente_id: obj.value }
        this.optionsListItemBclienteUsuario.push(item)
        if (this.form && this.form.empresa.length === 0 && item.label.includes('3')) {
          this.form.empresa = [item];
        }
      })
      this.$parent.optionsListItemBcliente.forEach((obj)=>
      {
          this.optionsListItemBcliente.push({ label: obj.label, bcliente_id: obj.value })
      });
      this.$parent.optionsListItemRole.forEach((obj)=>
      {
          this.optionsListItemRole.push({ label: obj.label, role_id: obj.value })
      });
      this.$parent.optionsListItemRoleUsuario.forEach((obj)=>
      {
          this.optionsListItemRoleUsuario.push({ label: obj.label, role_id: obj.value })
      });
      this.$parent.optionsListItemUnidade.forEach((obj)=>
      {
          this.optionsListItemUnidade.push({ label: obj.label, unidade_id: obj.value })
      });
      this.$parent.optionsListItemUnidadeUsuario.forEach((obj)=>
      {
          this.optionsListItemUnidadeUsuario.push({ label: obj.label, unidade_id: obj.value })
      });
      this.$parent.optionsLivStatus.forEach((obj)=>
      {
          this.optionsLivStatus.push({ text: obj.label, value: obj.value })
      });
      this.form.status = 1;
      this.$refs.modal_form.show();
    },
    onEdit (data)
    {
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Alterar";
        this.modal_botao = "Alterar";
        this.modal_acao = "u";
        this.form.reset();
        this.optionsLivStatus = [];
        this.transportadoraSelected = [];
        if(data.pessoa_transportadora != null)
        {
            this.transportadoraSelected = {label: data.pessoa_transportadora.pessoa_juridica.razao_social, value: data.pessoa_transportadora.pessoa_juridica.pessoa_id};
        }
        this.form.nome = data.pessoa.pessoa_fisica.nome;
        this.form.email = data.email;
        this.form.status = data.status.valor;
        this.form.tp_acesso = data.tp_acesso.valor;
        this.form.usuario_id = data.usuario_id;
        this.$parent.optionsLivStatus.forEach((obj)=>
        {
            this.optionsLivStatus.push({ text: obj.label, value: obj.value })
        });
        this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/'+this.rota+'/update/'+id).then(response =>
        {
            new ReturnApi(response, this);
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });

    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
    var cnpj_formatado
    var pad = "00000000";
    var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
    var pad = "0000"
    var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
    var pad = "00"
    var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;
    return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
          this.isLoadingTransportadora = true;
          this.helpForm.search = search;
          this.helpForm.status = 1;
          this.helpForm
          .post("/api/pessoa/jsonlist/transportadora")
          .then((response) => {
              this.optionsTransportadora = [];
              new ReturnApi(response, this, true, false, false);
              if (response.items.length > 0) {
              response.items.forEach((obj) => {
                  this.optionsTransportadora.push({
                  label: "PJ -" + obj.pessoa.cd + " - " + obj.razao_social + " - " + this.onFormataCnpj( obj.cnpj_base, obj.cnpj_filial, obj.cnpj_digito).replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") + " - " + obj.inscricao_estadual, pessoa_id: obj.pessoa_id, value: obj.pessoa_id,
                  });
              });
              }
              if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                  this.optionsTransportadora.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                  });
              });
              }
              if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                  this.optionsTransportadora.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                  });
              });
              }
              this.isLoadingTransportadora = false;
          })
          .catch((errors) => {
              new ReturnApi(errors, this);
          });
      }
  },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
